// En tu archivo de estado Recoil
import { atom } from 'recoil';

export const editModalState = atom({
  key: 'editModalStateAtom',
  default: {
    isOpen: false,
    onConfirm: () => {},
    onCancel: () => {},
    message: '',
    title: '',
  },
});
